import React from 'react';

const LocationIcon = () => (
  <svg className="search-icon" width="11px" height="15px" viewBox="0 0 11 15" version="1.1">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="searchbar-v2" transform="translate(-801.000000, -55.000000)" fill="#F96F12">
        <g id="searchbar">
          <g id="Group-2">
            <g id="Group-3" transform="translate(172.000000, 31.000000)">
              <g id="search-box">
                <g id="Group" transform="translate(629.000000, 24.000000)">
                  <g id="Group-4">
                    <path
                      d="M5.5,7.84031361 C4.28505,7.84031361 3.3,6.83731349 3.3,5.60022401 C3.3,4.36313453 4.28505,3.36013441 5.5,3.36013441 C6.71495,3.36013441 7.7,4.36313453 7.7,5.60022401 C7.7,6.83731349 6.71495,7.84031361 5.5,7.84031361 M5.5,0 C2.4629,0 0,2.50778031 0,5.60022401 C0,10.6398656 4.4,14 5.5,14 C6.6,14 11,10.6398656 11,5.60022401 C11,2.50778031 8.5371,0 5.5,0"
                      id="Fill-404"
                    />
                    <rect id="Rectangle-9" x="2" y="14" width="7" height="1" rx="0.5" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LocationIcon;
